export enum ContractQueryField {
  // ---------- CONTRACT INFO ----------
  id = 'id',
  externalId = 'externalId',
  contractCreationDate = 'contractCreationDate',
  contractReceivedProposalsCount = 'contractReceivedProposalsCount',
  contractAverageValueContribution = 'contractAverageValueContribution',
  contractActive = 'contractActive',
  // ---------- SUPPLIER ----------
  supplierId = 'supplierId',
  supplierExternalId = 'supplierExternalId',
  supplierName = 'supplierName',
  supplierEmployeeCount = 'supplierEmployeeCount',
  supplierIndustry = 'supplierIndustry',
  supplierLegalType = 'supplierLegalType',
  // ---------- LOCATION ----------
  supplierAddressCountry = 'supplierAddressCountry',
  supplierAddressCity = 'supplierAddressCity',
  supplierLocationRadius = 'supplierLocationRadius',
  // ---------- PRODUCTS ----------
  productId = 'productId',
  productName = 'productName',
  productExternalId = 'productExternalId',
  productCategory = 'productCategory',
  // ---------- SERVICES ----------
  serviceId = 'serviceId',
  serviceName = 'serviceName',
  serviceExternalId = 'serviceExternalId',
  serviceCategory = 'serviceCategory',
  // ---------- ORDERS ----------
  orderLastDate = 'orderLastDate',
  orderVolumeYear = 'orderVolumeYear',
  orderCountYear = 'orderCountYear',
  // ---------- COMMODITY GROUP ----------
  primaryCommodityGroupId = 'primaryCommodityGroupId',
  commodityGroup = 'commodityGroup',
  // ---------- SOURCE SYSTEM ----------
  sourceSystemName = 'sourceSystemName',
}

export enum ContractQueryFieldGroup {
  contract = 'contract',
  supplier = 'supplier',
  performance = 'performance',
  product = 'product',
  service = 'service',
  order = 'order',
  location = 'location',
  sourceSystem = 'sourceSystem',
  commodityGroup = 'commodityGroup',
}
